module.exports = __webpack_public_path__ + "img/11.046c0df0.jpg";